import { Html5QrcodeSupportedFormats } from 'html5-qrcode/src/core'
import { isOldSkrottlappCode, isNewSkrottlappCode } from 'prove-common'
import { QrcodeResult, QrcodeResultFormat } from 'html5-qrcode/core'

export type CodeTypes = 'sample' | 'skrottlapp'

const isValidSampleBagQRCode = (code: string) =>
  /^(?!A00000)[A-HJ-KM-NP-Z][A-HJ-KM-NP-Z0-9]{5}$/.test(code)

const isValidSampleBagBarcode = (code: string) => /^\d{6,7}$/.test(code)

export const inferFormatFromInput = (
  code: string,
  type: CodeTypes | null
): QrcodeResultFormat | undefined => {
  if (!code) return
  if (type === 'sample') {
    if (isValidSampleBagQRCode(code)) {
      return {
        format: Html5QrcodeSupportedFormats.QR_CODE,
        formatName: 'QR_CODE'
      }
    }
    if (isValidSampleBagBarcode(code)) {
      return {
        format: Html5QrcodeSupportedFormats.CODE_128,
        formatName: 'CODE_128'
      }
    }
  } else if (type === 'skrottlapp') {
    if (isOldSkrottlappCode(code)) {
      return {
        format: Html5QrcodeSupportedFormats.CODE_128,
        formatName: 'CODE_128'
      }
    }
    if (isNewSkrottlappCode(code)) {
      return {
        format: Html5QrcodeSupportedFormats.DATA_MATRIX,
        formatName: 'DATA_MATRIX'
      }
    }
  }
}

export const isValidCode = (
  result: QrcodeResult,
  type: CodeTypes | null
): boolean => {
  const format = result.format?.format
  const text = result.text
  if (type === 'sample') {
    if (format === Html5QrcodeSupportedFormats.QR_CODE)
      return isValidSampleBagQRCode(text)
    if (format === Html5QrcodeSupportedFormats.CODE_128)
      return isValidSampleBagBarcode(text)
  }
  if (type === 'skrottlapp') {
    const matchesContent =
      isOldSkrottlappCode(text) || isNewSkrottlappCode(text)
    const matchesFormat =
      format === Html5QrcodeSupportedFormats.CODE_128 ||
      format === Html5QrcodeSupportedFormats.DATA_MATRIX
    return matchesContent && matchesFormat
  }
  return false
}

export const buildTitle = (type: CodeTypes | null) => {
  let title = 'Les kode'
  if (type === 'sample') title += ' på prøveposen'
  if (type === 'skrottlapp') title += ' på skrottlappen'
  return title
}
